/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Spinner } from 'reactstrap';

import { useAuth } from './app/hooks/auth';
import ManagerProvider from './app/hooks/manager';
import AppAdminRoutes from './app/routes/app.admin.routes';
import AuthRoutes from './app/routes/auth.routes';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tabs/style/react-tabs.css';
import 'animate.css';
import './app/assets/vendor/fontawesome-free-5.15.2-web/css/all.min.css';
import './app/assets/vendor/fontawesome-free-6.2.0-web/css/all.min.css';
import './app/assets/css/bootstrap.css';
import './app/assets/css/bootstrap9.css';
import './app/assets/css/custom.css';

const loading = (
  <div
    className="bg-primary opacity-7 d-flex w-100 vh-100 align-items-center justify-content-center position-fixed left-0 top-0"
    style={{ zIndex: 999999 }}
  >
    <Spinner type="grow">
      Carregando...
    </Spinner>
  </div>
);

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <Router>
      <Suspense fallback={loading}>
        {isAuthenticated ? (
          <ManagerProvider>
            <AppAdminRoutes />
          </ManagerProvider>
        ) : (
          <AuthRoutes />
        )}
      </Suspense>
    </Router>
  );
}

export default App;
